<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.ab_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.ab_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.ab_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.ab_badge_holder" prop="user_id">
                <!-- <el-input
                  type="text"
                  v-model="mData.dataForm.user_id"
                  :disabled="mData.viewMode != 'create'"
                  clearable
                ></el-input> -->
                 <el-input
                  type="text"
                  v-model="mData.dataForm.ten_user"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
                <!-- <el-select
                      v-model="mData.dataDefault.itemHuongDanVien"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                      placeholder="Nhập họ tên hoặc số thẻ (nhấn enter để tìm kiếm)"
                      no-data-text="Chưa có dữ liệu"
                      :filter-method="fn_remoteGetListHuongDanVien"
                      @keyup.enter.native="fn_enterFindHuongDanVien()"
                      @change="fn_addHuongDanVien(mData.dataDefault.itemHuongDanVien)"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listHuongDanVien"
                        :key="item.id"
                        :label="item.ho_ten.ho_ten + ' - số thẻ '+ item.the_hdv.so_the"
                        :value="item"
                      ></el-option>
                    </el-select> -->
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.ab_badge" prop="huy_hieu_id">
                <el-select
                  v-model="mData.dataForm.huy_hieu_id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listHuyHieu"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.ab_note" prop="ghi_chu">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ghi_chu"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>            
          </b-row>
          <b-row v-if="mData.viewMode == 'detail'">
            <b-col md="6">
              <el-form-item :label="aLang.ab_created_time" prop="thoi_diem_tao">
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.thoi_diem_tao"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                >clearable</el-date-picker>
              </el-form-item>
            </b-col>
            <!-- <b-col md="6">
              <el-form-item label="Người cấp" prop="nguoi_cap_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.nguoi_cap_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> -->
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ThanhTichHuyHieuModel from "./ThanhTichHuyHieuModel";
import ThanhTichHuyHieuApi from "../../../moduleApi/ThanhTichHuyHieuApi";
import HuyHieuApi from "../../../moduleApi/HuyHieuApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";

export default {
  data() { 
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "ThanhTichHuyHieu",
        dataDefault: {
          roles: DataService.rolesInForm,
          listHuyHieu:[],
          listHDV:[],
          textFindHuongDanVien: "",
          listHuongDanVien: [],       
          itemHuongDanVien: null,
        },
        dataForm: MethodService.copyObject(ThanhTichHuyHieuModel.dataForm),
        validForm: ThanhTichHuyHieuModel.validForm,
        dialog: {} 
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await ThanhTichHuyHieuApi.create(this.mData.dataForm);
            this.fn_resetForm();
            this.fn_go(-1);
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await ThanhTichHuyHieuApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await ThanhTichHuyHieuApi.findById(id);
      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(ThanhTichHuyHieuModel.dataForm),
        res.result
      );
      // if (res.result){
      //   let resHDV= await HuongDanVienApi.findById(res.result.user_id);        
      //   this.mData.dataDefault.itemHuongDanVien=resHDV.result;
      //   this.mData.dataDefault.listHuongDanVien.push(resHDV.result);    
      // }

      let resKhachDuLichApi = await KhachDuLichApi.findById(
        resData.user_id
      );
      if (resKhachDuLichApi.result) {
        resData.ten_user = resKhachDuLichApi.result.ho_ten.ho_ten;        
      } else {
        let resHuongDanVienApi = await HuongDanVienApi.findById(
          resData.user_id
        );       
        if (resHuongDanVienApi.result) {
          resData.ten_user = resHuongDanVienApi.result.ho_ten.ho_ten;          
        } else {
          let resDiemDenAnToanApi = await DiemDenAnToanApi.findById(
            resData.user_id
          );       
          if (resDiemDenAnToanApi.result) {
            resData.ten_user = resDiemDenAnToanApi.result.thong_tin_chung.ten;          
          } else {
            resData.ten_user="";
          }
        }
      }
      
      this.mData.dataForm = resData; //res.result;
    },
    async fn_initDataDefault() {
        let resHuyHieu=await HuyHieuApi.list({limit:1000});        
        this.mData.dataDefault.listHuyHieu=resHuyHieu.result;
    },

    async fn_remoteGetListHuongDanVien(query) {
      this.mData.dataDefault.textFindHuongDanVien = query;
    },
    async fn_enterFindHuongDanVien() {
      if (this.mData.dataDefault.textFindHuongDanVien) {
        let resHuongDanVienApi = await HuongDanVienApi.list({
          limit: 1000,
          filters: `the_hdv.so_the=${this.mData.dataDefault.textFindHuongDanVien}`
        });
        if (resHuongDanVienApi.result && resHuongDanVienApi.result.length>0){
          this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;
        }

        let resHuongDanVien1Api = await HuongDanVienApi.list({
          limit: 1000,
          filters: `ho_ten.ho_ten:regex_i:${this.mData.dataDefault.textFindHuongDanVien}`
        });
        if (resHuongDanVien1Api.result && resHuongDanVien1Api.result.length>0){
          this.mData.dataDefault.listHuongDanVien = resHuongDanVien1Api.result;
        }
        
      }
      this.mData.dataDefault.textFindHuongDanVien = "";
    },
    fn_addHuongDanVien(item) {
      if (item) {
        // debugger;
        this.mData.dataForm.user_id=item.id;
        // this.mData.dataDefault.itemHuongDanVien = null;
        // this.mData.dataDefault.listHuongDanVien = [];    
      }
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>